import { createInterfaceId, Injectable } from '@gitlab-org/di';
import { PromiseFsClient } from 'isomorphic-git';

export interface FsClient extends PromiseFsClient {}

export const FsClient = createInterfaceId<FsClient>('FsClient');

const notImplemented = async () => {
  throw new Error('Not implemented');
};

@Injectable(FsClient, [])
export class EmptyFsClient implements FsClient {
  promises: PromiseFsClient['promises'] = {
    readFile: notImplemented,
    writeFile: notImplemented,
    unlink: notImplemented,
    readdir: notImplemented,
    mkdir: notImplemented,
    rmdir: notImplemented,
    stat: notImplemented,
    lstat: notImplemented,
  };
}
